import React from 'react';
import { Lightbulb } from 'lucide-react';
interface InsightBarProps {
  title?: string;
  message: string | React.ReactNode;
  className?: string;
}
export function InsightBar({
  title = 'Inzicht',
  message,
  className = ''
}: InsightBarProps) {
  return <div className={`bg-indigo-50/50 border border-indigo-100 rounded-2xl p-4 flex items-center gap-4 ${className}`} data-id="element-9842" data-mp="2i5ixpad2cgnu">
      
      <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0" data-id="element-9843" data-mp="2s1c4se80jhy8">
        <Lightbulb className="w-5 h-5 text-indigo-600" data-id="element-9844" data-mp="2n30uy3hpx7g0" />
      </div>
      <div className="flex-1" data-id="element-9845" data-mp="2n4vhtncjv9mq">
        <h3 className="text-sm font-bold text-indigo-900 mb-1" data-id="element-9846" data-mp="312sfkn2qpm2z">{title}</h3>
        <div className="text-sm text-indigo-700" data-id="element-9847" data-mp="2x0p3pxc5sfh6">{message}</div>
      </div>
    </div>;
}